<template>
  <div class="cmp-product-price" v-if="showPrices" :class="parentClassRef">
    <ul class="price-list flex-row-nowrap align-items-baseline">
      <template v-if="prices.rawPrice != 0">        
        <!-- BESPOKE RUT-21: Added excl label and span salesAction-->
        <li class="default">
          <span>{{ prices.price }}</span>
          <span v-if="prices.isSalesAction" class="original salesaction">{{ prices.basePrice }}</span>
          <span v-translation="{ code: 'label_price1_excl_vat', type: 'label' }" class="vat-label"></span>          
        </li>        
        <!-- END BESPOKE RUT-21 -->

        <!-- BESPOKE RUT-21: Added excl label, price excl VAT <li> and span salesAction -->
        <li class="default price-incl">          
          <span>{{ priceDefaultIncl }}</span>
          <span v-if="prices.isSalesAction" class="original salesaction">{{ priceSalesActionIncl }}</span>
          <span v-translation="{ code: 'label_price1_incl_vat', type: 'label' }" class="vat-label"></span>
        </li>        
        <!-- END BESPOKE RUT-21 -->
        
        <!-- BESPOKE RUT-21: Disabled salesAction -->
        <!-- <li v-if="prices.isSalesAction" class="original salesaction">
          <span>{{ prices.basePrice }}</span>
        </li> -->
        <!-- END BESPOKE RUT-21 -->
      </template>
      
      <!-- BESPOKE RUT-20: Added price on request -->
      <template v-else>
        <li>
          <div class="price-on-request">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <span v-translation="{ code: 'label_price_on_request', type: 'label' }"></span>
          </div>
        </li>
      </template>
      <!-- END BESPOKE RUT-20 -->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatPrice } from 'src/utilities/helpers';
export default {
  props: {
    prices: { type: Object, required: false },
    parentClassRef: { type: String, default: '', required: false },
    productVatPercentage: { type: Number, required: false, default: 0 }
  },
  computed: {
    // BESPOKE RUT-20
    // Added bespokeUserinformation
    // Added vatPercentage and formattedPrices taking VAT into account
    ...mapGetters(['showPrices', 'bespokeUserInformation']),
    vatPercentage () {
      return this.bespokeUserInformation.vatPercentage !== null ? this.bespokeUserInformation.vatPercentage : this.productVatPercentage;
    },
    priceDefaultIncl () {
      console.log(this.prices.rawBasePrice, this.vatPercentage)
      return formatPrice(this.prices.rawPrice * (1 + this.vatPercentage / 100));
    },
    priceSalesActionIncl () {      
      return formatPrice(this.prices.rawBasePrice * (1 + this.vatPercentage / 100));
    }
    // END BESPOKE RUT-20
  }
}
</script>

<style>

</style>
